<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="page-main">
      <div class="panel-heading">
        <el-button plain icon="el-icon-arrow-left" @click="backToMyDomain"></el-button>
        <span class="se-panel-title z-padding-left-5-precent ver-sub">域名管理</span>
      </div>
      <div class="server-header domain" v-loading="loading2">
        <span class="header-center-text">{{dn_top}}</span>
        <p>
          <span>域名：{{domain.name}}</span>
          <span>所有者：{{organizeman_cn}}</span>
        </p>
        <p>
          <span>有效期：{{applyDate}} 至 {{expireDate}}</span>
        </p>
        <p>
          <span>实名认证：{{shiming}}</span>
        </p>
        <p>
          <span>
            DNS地址：
            <span v-for="options in dns">
              {{options}}&nbsp;
            </span>
          </span>
        </p>
      </div>
      <el-tabs v-model="activeName" type="border-card">
        <el-tab-pane label="域名解析" name="first">
          <div ref="alert" style="visibility: hidden">
            <div v-if="shiming !== '实名审核通过'" class="alert-warn">
              需进行实名认证后解析才能生效！
              <br>
              子域名只需要填前缀即可，没有前缀不需要填。例如www.sanfengyun.com.填www，sanfengyun.com不需要填。
            </div>
            <div v-if="dns[0] === 'ns1.dns-diy.com' && dns[1] === 'ns2.dns-diy.com'" class="alert-warn">
              您的域名DNS为35互联DNS，请登录35互联解析平台进行解析。
            </div>
            <div v-if="!dnsstr.includes('.sfydns.com') && !dnsstr.includes('.xinnet.com') && !dnsstr.includes('.xincache.com')" class="alert-warn">
              您域名的DNS设置不是三丰云的DNS，请到您DNS提供商处进行解析，或将DNS设置为三丰云DNS再进行解析。
            </div>
          </div>
          <div v-if="dnsstr.includes('.sfydns.com') || dnsstr.includes('.xinnet.com') || dnsstr.includes('.xincache.com')" class="ub-box z-margin-top-5-precent z-margin-bottom-20-precent">
            <div class="domain-analy">
              <el-button type="primary" icon="el-icon-plus" size="mini" class="z-margin-left-8-precent z-vertical-align" @click="add">新记录</el-button>
            </div>
          </div>
          <el-table v-if="dnsstr.includes('.sfydns.com') || dnsstr.includes('.xinnet.com') || dnsstr.includes('.xincache.com')" :data="analyList" highlight-current-row show-header v-loading="listLoading" class="jiexi table-empty" style="width: 100%;">
            <el-table-column prop="type" label="解析类型" align="left">
              <template slot-scope="scope">
                <el-select v-if="scope.row.index === -1" v-model="scope.row.type" size="mini">
                  <el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <span v-if="scope.row.index != -1">{{scope.row.type}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="子域名" align="left">
              <template slot-scope="scope">
                <el-input v-if="scope.row.index === -1" v-model="scope.row.title" size="mini" placeholder="子域名只需填前缀"></el-input>
                <span v-if="scope.row.index != -1">{{scope.row.title}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="content" label="指向" align="left">
              <template slot-scope="scope">
                <el-input v-if="scope.row.index === tableidx" v-model="scope.row.content" size="mini"></el-input>
                <span v-if="scope.row.index != tableidx">{{scope.row.content}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="ttl" label="TTL" align="left">
              <template slot-scope="scope">
                <el-select v-if="scope.row.index === tableidx" v-model="scope.row.ttl" size="mini">
                  <el-option v-for="item in ttl" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <span v-if="scope.row.index != tableidx">{{scope.row.ttl}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="mx" label="优先级" align="left">
              <template slot-scope="scope">
                <el-input v-if="scope.row.index === -1 && scope.row.type ==='mx'" v-model="scope.row.mx" size="mini"></el-input>
                <span v-if="scope.row.index != -1">{{scope.row.mx}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="caozuo" label="操作" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.index != tableidx" class="z-curPonit z-color-a" @click="revise(scope.row.index)">修改</span>
                <span v-if="scope.row.index === tableidx && scope.row.index != -1" class="z-curPonit z-color-a" @click="save(scope.row.id,scope.row.mx,scope.row.content,scope.row.ttl,scope.row.type,scope.row.title)">保存</span>
                <span v-if="scope.row.index === -1" class="z-curPonit z-color-a" @click="setUp">创建</span>
                &nbsp;&nbsp;
                <span v-if="scope.row.index != tableidx" class="z-curPonit z-color-a" @click="delJieru(scope.row.id,scope.row.type,scope.row.title,scope.row.content)">删除</span>
                <span v-if="scope.row.index === tableidx" class="z-curPonit z-color-a" @click="cancel">取消</span>
              </template>
            </el-table-column>
            <span slot="empty">
              域名列表为空，
              <a class="z-curPonit z-color-a" href="javascript:;" @click="add">添加新纪录&gt;&gt;</a>
            </span>
          </el-table>
          <el-pagination v-if="dnsstr.includes('.sfydns.com') || dnsstr.includes('.xinnet.com') || dnsstr.includes('.xincache.com')" background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange1" :page-size="10" :total="total1" class="pull-left">
          </el-pagination>
          <el-pagination v-if="dnsstr.includes('.sfydns.com') || dnsstr.includes('.xinnet.com') || dnsstr.includes('.xincache.com')" background layout="prev, pager, next" @current-change="handleCurrentChange1" :page-size="count1" :total="total1">
          </el-pagination>
          <form v-if="dns[0] === 'ns1.dns-diy.com' && dns[1] === 'ns2.dns-diy.com'" action="http://www.dns-diy.com/login.aspx" method="POST" target="_blank">
            <el-input name="username" v-model="domain.name" readonly="readonly" auto-complete="off" style="width: 300px"></el-input>
            <el-input name="password" v-model="domain.password" type="password" readonly="readonly" auto-complete="off" style="width: 300px"></el-input>
            <input type="submit"  value="登录" class="el-button el-button--small el-button--primary">
          </form>
        </el-tab-pane>
        <el-tab-pane label="获取域名证书" name="second">
          <div class="alert-warn">
            如需获取域名证书截图，请点击获取证书截图按钮，然后将网页另存为图片即可
          </div>
          <div class="ub-box ub-ver-h">
            <el-button type="primary" size="mini" @click.stop="printdiv">打印证书</el-button>
            <el-button type="primary" size="mini" class="z-margin-left-8-precent" @click="goCertificate">获取证书截图</el-button>
          </div>
          <div class="z-margin-bottom-25-precent" id="div_print">
            <div v-if="domain.org === 'xinnet'">
              <meta charset="utf-8">
              <title>国际域名证书</title>
              <div class="int">
                <img src="../../assets/imgs/logo-xinnet_icann.gif" alt="" class="int-logo" height="73" width="223">
                <img src="../../assets/imgs/int.png" height="77" width="333" alt="" class="int-title">
                <div class="int-text">
                  <p class="int-p"><b class="z-font-weight-700">国际顶级域名权威机构ICANN</b>(The Internet Corporation for Assigned Names and Numbers)授权新网Xinnet.com制作并颁发此证。<b class="z-font-weight-700">证明：</b></p>
                  <p class="int-p">域名<span class="blue">{{domain.name}}</span>已通过<span class="blue">北京新网数码信息技术有限公司</span>完成注册，并已在国际顶级域名数据库中备案。</p>
                  <p class="int-p">This certificate was issued by xinnet.com, which is authorized by ICANN(The Internet Corporation for Assigned Names and Numbers).</p>
                  <p class="int-p">This is to certify that <span class="red">Xin Net Technology Corporation</span> has registered the domain name <span class="red">ykykk.cn</span> and the registration has taken effect since it was put on records in the database of gTLD(global Top Level Domain) in ICANN.</p>
                  <table style="table-layout:fixed;" class="int-tab" width="500" cellspacing="0" cellpadding="2" border="1" bordercolordark="#FFFFFF" bordercolorlight="#666666">
                    <tbody><tr>
                      <td align="right" width="30%">域名：</td>
                      <td>{{domain.name}}</td>
                    </tr>
                    <tr>
                      <td align="right">Domain Name：</td>
                      <td>{{domain.name}}</td>
                    </tr>
                    <tr>
                      <td align="right">注册所有人：</td>
                      <td style="word-wrap:break-word;">{{organizeman_cn}}</td>
                    </tr>
                    <tr>
                      <td align="right">Registrant：</td>
                      <td style="word-wrap:break-word;">{{organizeman_uk}}</td>
                    </tr>
                    <tr>
                      <td align="right">注册时间：</td>
                      <td>{{applyDate}}</td>
                    </tr>
                    <tr>
                      <td align="right">Registration Date：</td>
                      <td>{{applyDate}}</td>
                    </tr>
                    <tr>
                      <td align="right">到期时间：</td>
                      <td>{{expireDate}}</td>
                    </tr>
                    <tr>
                      <td align="right">Expiration Date：</td>
                      <td>{{expireDate}}</td>
                    </tr>
                    <tr>
                      <td align="right">通信地址：</td>
                      <td style="word-wrap:break-word;">{{street_cn}}</td>
                    </tr>
                    <tr>
                      <td align="right">Address：</td>
                      <td style="word-wrap:break-word;">{{street_uk}}</td>
                    </tr>
                    </tbody></table>
                  <p class="int-p2">本证书仅用于证明该域名是通过北京新网数码信息技术有限公司注册，且信息为当时域名信息。本证书并不做为其他证明文件之用！<br>北京新网数码信息技术有限公司是北京首家获ICANN授权的国际域名注册服务商</p>
                  <img src="../../assets/imgs/zhang.gif" height="144" width="200" alt="" class="int-seal">
                </div>
                <p class="int-p3">鉴别本证书的真伪，请访问<a href="http://www.xinnet.com" target="blank">http://www.xinnet.com</a>进行查询！</p>
                <img src="../../assets/imgs/xinnet-bg.png" width="616px" height="876px" style="position:absolute;top:0;left:0;z-index:-1;"></div>
            </div>
            <div v-if="domain.org === '35'">
              <meta charset="utf-8">
              <title>国际域名证书</title>
              <div class="int-35">
                <div style="margin:15px 0 20px 54px">
                  <img src="../../assets/imgs/35-title.gif" width="350" height="65">
                  <img width="139" height="135" src="../../assets/imgs/coin.gif" style="margin-left: 34px;">
                </div>
                <div class="int-text-35">
                  <p>作为互联网名称与数字地址分配机构ICANN(The Internet Corporation for Assigned Names and Numbers)认证的域名注册服务机构，厦门三五互联科技股份有限公司(35.com)制作并颁发此证。</p>
                  <p><strong><br>
                  </strong><span style="font-weight:700;">证明</span>：</p>
                  <p align="left"><span style="font-weight:700;">域名</span><strong><span style="color:red"> {{domain.name}} </span></strong><span style="font-weight:700;">已由</span><strong><span style="color:red">{{organizeman_cn}}</span></strong><strong></strong><span style="font-weight:700;">注册，并已在国际顶级域名数据库中记录。</span></p>
                  This certificate is issued by 35.com, which is authorized by ICANN (The Internet Corporation for Assigned Names and Numbers).<br>

                  This is to certify that
                  <span style="color:red">{{organizeman_uk}}</span>
                  has registered the domain name
                  <span style="color:red">{{domain.name}}</span>
                  and the registration has taken effect since it was put on records in the database of TLD (Top Level Domain) in ICANN.
                  <br>
                  <br>
                  <table width="100%" border="1" cellspacing="0" cellpadding="2" bordercolorlight="#666666" bordercolordark="#FFFFFF">
                    <tbody><tr>
                      <td width="45%" align="right">
                        <div align="left">域名(Domain Name)：</div>
                      </td>
                      <td width="55%" align="left" valign="middle">{{domain.name}}</td>
                    </tr>
                    <tr>
                      <td width="45%" align="right">
                        <div align="left">注册人或注册组织全称(Registrant,中文)：</div>
                      </td>
                      <td width="55%" align="left" valign="middle">{{organizeman_cn}}</td>
                    </tr>
                    <tr>
                      <td width="45%" align="right">
                        <div align="left">注册人或注册组织全称(Registrant,English)：</div>
                      </td>
                      <td width="55%" align="left" valign="middle">{{organizeman_uk}}</td>
                    </tr>
                    <tr>
                      <td width="45%" align="right">
                        <div align="left">注册时间(Registration Date)：</div>
                      </td>
                      <td width="55%" align="left" valign="middle">{{applyDate}}</td>


                    </tr>
                    <tr>
                      <td width="45%" align="right">
                        <div align="left">到期时间(Expiration Date)：</div>
                      </td>
                      <td width="55%" align="left" valign="middle">
                        {{expireDate}}</td>
                    </tr>
                    <tr v-for="(options, index) in dns">
                      <td width="45%" align="right">
                        <div align="left">域名服务器(Domain Name Server){{index+1}}：</div>
                      </td>
                      <td width="55%" align="left" valign="middle">{{options}}</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td width="55%" align="left" valign="middle">
                        <div style="position:relative;">
                          <div id="Layer2" style="position:absolute; width:115.5pt; height:114.75pt; z-index:2;left:66px;top:-120px">
                            <img src="../../assets/imgs/noagent.gif" width="153" height="152">
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody></table>
                  <br>
                  <br>
                  <br>
                  <p>以下说明与本证书主文一起构成本证书统一整体，不可分割：<br>
                    <br>
                    1．本证书为厦门三五互联科技股份有限公司自行制作，本证书主文表示其所列之组织或个人系所列域名之持有人，该证书对外不具有其他任何法律效力。<br>
                    2．本证书主文并不表明厦门三五互联科技股份有限公司对本证书主文中所列域名是否贬斥、侵害或毁损任何第三人之合法权利或利益作出任何明示或默示之评判、确认、担保，或作出其它任何形式之意思表示。厦门三五互联科技股份有限公司亦无任何责任或义务作出上述之评判、确认、担保，或作出其它任何形式之意思表示。<br>
                    3．因本证书主文中所列域名之注册或使用而可能引发与任何第三人之纠纷或冲突,均由该域名注册人本人承担，厦门三五互联科技股份有限公司不承担任何法律责任。厦门三五互联科技股份有限公司亦不在此类纠纷或冲突中充当证人、调停人或其它形式之参与人。<br>
                    4．本证书不得用于非法目的，厦门三五互联科技股份有限公司不承担任何由此而发生或可能发生之法律责任。<br>
                    当本证书持有、出具、展示或以其它任何形式使用时，即表明本证书之持有人或接触人已审读、理解并同意以上各条款之规定。</p>
                    <p style="text-align: center">ID:6956E5C315C3E758D2AD2CB67DE6E5FF</p>
                </div>
                <div style="background-color: #ccc;text-align: center">鉴别本证书的真伪，请访问 <a href="https://cp.35.com/chinese/whois.php">https://cp.35.com/chinese/whois.php</a>进行查询。</div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!--<el-tab-pane label="实名认证" name="third">实名认证</el-tab-pane>-->
        <el-tab-pane label="修改域名DNS" name="fourth">
          <div class="alert-warn">
            <span class="z-font-size-14 z-font-weight-700">相关说明</span>
            <br>
            1、如果您选择“使用我公司的域名服务器进行解析”，那么您就可以使用三丰云的域名解析功能，在线自助进行A纪录、MX记录、CNAME等相关解析记录的配置。
            <br>
            2、DNS修改会实时提交注册局生效，各地运营商DNS约需要24-48小时方可完全刷新同步，请耐心等待。
            <br>
          </div>
          <div class="ub-box ub-ver-h">
            <el-card class="box-card" :body-style="{ padding: '30px' }">
              <div class="z-padding-left-60-precent">
                <el-radio-group v-model="changedns" @change="choiceDns">
                  <el-radio label="1">使用我公司DNS解析</el-radio>
                  <el-radio label="2">使用自定义DNS解析</el-radio>
                </el-radio-group>
              </div>
              <el-form  label-width="80px" class="z-margin-top-20-precent">
                <el-form-item label="DNS1：">
                  <el-input v-model="dns1" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="DNS2：">
                <el-input v-model="dns2" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-button type="primary" size="mini" @click="ChangeDns">提交</el-button>
                </el-form-item>
              </el-form>
            </el-card>
          </div>
        </el-tab-pane>
        <el-tab-pane label="修改联系人信息" name="five">
          <el-form :model="LinkmanForm" :rules="rules" ref="LinkmanForm" label-width="400px" class="change-info-form z-margin-top-20-precent">
            <el-form-item label="域名所有者 (中文)：" prop="state">
              {{LinkmanForm.r_organize_name_cn}} <span class="z-color-red z-font-size-13">如需修改域名所有人，请联系客服申请过户</span>
            </el-form-item>
            <el-form-item label="域名联系人：" prop="r_user_name_cn">
              <el-input v-model="LinkmanForm.r_user_name_cn" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="所属区域：" prop="state">
              <xdomain-city :province="cityInfo['province']" :city="cityInfo['city']" :area="cityInfo['area']" :DISTRICTS="DISTRICTS" v-model="cityInfo"></xdomain-city>
            </el-form-item>
            <el-form-item label="通讯地址（中文）：" prop="r_street_cn">
              <el-input v-model="LinkmanForm.r_street_cn" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="邮编：" prop="r_zip">
              <el-input v-model="LinkmanForm.r_zip" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="r_phone_n">
              <el-input v-model="LinkmanForm.r_phone_c" size="mini" class="phone-c"></el-input> -
              <el-input v-model="LinkmanForm.r_phone_a" size="mini" class="phone-a"></el-input> -
              <el-input v-model="LinkmanForm.r_phone_n" size="mini" class="phone-n"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱：" prop="r_email">
              <el-input v-model="LinkmanForm.r_email" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="提醒：" prop="state" class="tixing">
              <p class="z-color-red z-font-size-13">com等国际域名的 所有者信息以英文为准，请不要缩写或简写。</p>
              <p class="z-color-red z-font-size-13">系统已自动翻译成拼音全拼，如您有英文名称或翻译有误，请直接进行修改。</p>
            </el-form-item>
            <el-form-item label="域名所有者名称 （拼音）：" prop="r_organize_name_uk">
              {{LinkmanForm.r_organize_name_uk}} <span class="z-color-red z-font-size-13">如需修改域名所有人，请联系客服申请过户</span>
            </el-form-item>
            <el-form-item label="域名联系人名称 （拼音）：" prop="r_user_name_uk">
              <el-input v-model="LinkmanForm.r_user_name_uk" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="省份（拼音）：" prop="r_province_uk">
              <el-input v-model="LinkmanForm.r_province_uk" size="mini" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="城市（拼音）：" prop="r_city_uk">
              <el-input v-model="LinkmanForm.r_city_uk" size="mini" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="通讯地址（拼音）：" prop="r_street_uk">
              <el-input v-model="LinkmanForm.r_street_uk" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary" @click="submitForm('LinkmanForm')">保存</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="操作记录" name="six">
          <el-table :data="recordList" highlight-current-row show-header v-loading="listLoading" style="width: 100%;">
            <el-table-column prop="settime" label="操作时间" min-width="250" align="left">
            </el-table-column>
            <el-table-column prop="ac_type" label="操作类型" max-width="250" align="left">
            </el-table-column>
            <el-table-column prop="set_type" label="解析类型" max-width="250" align="left">
            </el-table-column>
            <el-table-column prop="title" label="记录名称" max-width="250" align="left">
            </el-table-column>
            <el-table-column prop="content" label="指向地址" min-width="250" align="left">
            </el-table-column>
            <el-table-column prop="ttl" label="TTL" max-width="250" align="center">
            </el-table-column>
            <el-table-column prop="ac_ip" label="操作IP" max-width="250" align="center">
            </el-table-column>
            <el-table-column prop="ac_from" label="来源" max-width="250" align="center">
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange2" :page-size="10" :total="total2" class="pull-left">
          </el-pagination>
          <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange2" :page-size="count2" :total="total2">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
      <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
      <xdialog-warning :dialogWarning="dialogWarning" :warningMsg="warningMsg"></xdialog-warning>
    </div>
  </div>
</template>
<script>
  import XdomainCity from 'components/commons/XdomainCity.vue'
  import domainService from 'business/domainService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import XdialogWarning from 'components/commons/XdialogWarning.vue'
  import {ConvertPinyin} from 'utils/Pinyin'
  import {IsEmail} from 'utils/areaCodeValidate'
  export default {
    data () {
      var checkEmailLength = (rule, value, callback) => {
        if(!IsEmail(value)){
          return callback(new Error('邮箱格式错误，请重新输入！'));
        }else {
          callback();
        }
      };
      return {
        dialogSuccess:false,
        dialogLoading:false,
        dialogWarning:false,
        listLoading:false,
        loading2:false,
        warningMsg:'',
        activeName:'first',
        dn_top:'',
        organizeman_cn:'',
        organizeman_uk:'',
        applyDate:'',
        expireDate:'',
        street_cn:'',
        street_uk:'',
        shiming:'',
        isChinese:'E',
        dns:[],
        dnsstr:'',
        analyList:[],
        type: [{
          value: 'a',
          label: 'A记录'
        }, {
          value: 'cname',
          label: 'CNAME记录'
        }, {
          value: 'mx',
          label: 'MX记录'
        }, {
          value: 'txt',
          label: 'TXT记录'
        }, {
          value: 'aaaa',
          label: 'IPv6记录'
        }],
        ttl: [{
          value: '600',
          label: '10分钟'
        }, {
          value: '1800',
          label: '30分钟'
        }, {
          value: '3600',
          label: '1小时'
        }, {
          value: '7200',
          label: '2小时'
        }],
        tableidx:1000,
        domain:{},
        search:'',
        count1:10,
        total1:0,
        page1:1,
        count2:10,
        total2:0,
        page2:1,
        changedns:'1',
        dns1:'ns11.xincache.com',
        dns2:'ns12.xincache.com',
        recordList:[],
        oldcontent:'',
        DISTRICTS:[],
        cityInfo: {
          province:'中国',
          city:'北京市',
          area:'北京市'
        },
        cityPinyin: {
          province:'china',
          city:'beijingshi',
          area:'shixiaqu'
        },
        LinkmanForm:{
          r_organize_name_cn : '',
          r_user_name_cn : '',
          r_street_cn : '',
          r_zip : '',
          r_phone : '',
          r_phone_c : '',
          r_phone_a : '',
          r_phone_n : '',
          r_email : '',
          r_organize_name_uk : '',
          r_user_name_uk : '',
          r_country_uk : '',
          r_province_uk : '',
          r_city_uk : '',
          r_street_uk : '',
          r_province_cn : '',
          r_city_cn : '',
        },
        rules: {
          r_user_name_cn: [
            { required: true, message: '该项必填', trigger: 'blur' },
            { pattern: /.*[\u4e00-\u9fa5]+.*$/, message: '只允许输入中文、英文、数字,且必须含有中文' },
            { pattern: /^[a-z0-9A-Z\u4e00-\u9fa5-(.,、)/\\ 《》（）&'"·\“\”]+$/, message: '特殊字符允许输入 .,、《》() -"“”&/\'·及空格' },
            { max: 64, message: '输入字符个数不能大于64'}
          ],
          r_street_cn: [
            { required: true, message: '该项必填', trigger: 'blur' },
            { pattern: /.*[\u4e00-\u9fa5]+.*$/, message: '只允许输入中文、英文、数字,且必须含有中文' },
            { pattern: /^[a-z0-9A-Z\u4e00-\u9fa5-(.,、)/\\ 《》（）&'"·\“\”]+$/, message: '特殊字符允许输入 .,、《》() -"“”&/\'·及空格' },
            { max: 64, message: '输入字符个数不能大于64'}
          ],
          r_zip: [
            { required: true, message: '该项必填', trigger: 'blur' },
            { pattern: /^([0-9])*$/ , message: '邮编限6~10位数字' },
            { min: 6, message: '输入字符个数不能小于6'},
            { max: 10, message: '输入字符个数不能大于10'},
          ],
          r_email: [
            { required: true, message: '该项必填', trigger: 'blur' },
            { validator: checkEmailLength , trigger: 'blur' },
            { max: 63, message: '输入字符个数不能大于63位'}
          ],
          r_user_name_uk: [
            { required: true, message: '该项必填', trigger: 'blur' },
            { pattern: /.*[a-zA-Z]+.*$/, message: '只允许输入英文、数字,且必须含有英文' },
            { pattern: /^[a-z0-9A-Z-(.,、)/\\ （）&'"·\“\”]+$/, message: '特殊字符允许输入 .,、() -"“”&/\'及空格符' },
            { max: 64, message: '输入字符个数不能大于64'}
          ],
          r_province_uk: [
            { required: true, message: '省份不能为空！', trigger: 'blur' }
          ],
          r_city_uk: [
            { required: true, message: '城市不能为空！', trigger: 'blur' }
          ],
          r_street_uk: [
            { required: true, message: '该项必填', trigger: 'blur' },
            { pattern: /.*[a-zA-Z]+.*$/, message: '只允许输入英文、数字,且必须含有英文' },
            { pattern: /^[a-z0-9A-Z-(.,、)/\\ （）&'"·\“\”]+$/, message: '特殊字符允许输入 .,、() -"“”&/\'及空格符' },
            { max: 64, message: '输入字符个数不能大于64'}
          ],
        },
      }
    },
    components:{
      XdomainCity,
      XdialogLoading,
      XdialogWarning
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.config()
    },
    computed: {
      city() {
        return this.cityInfo.city
      },
      area() {
        return this.cityInfo.area
      },
      r_user_name_cn() {
        return this.LinkmanForm.r_user_name_cn
      },
      r_street_cn() {
        return this.LinkmanForm.r_street_cn
      },
    },
    watch:{
      activeName(val){
        if(val === 'first'){
          this.page1 = 1
          this.SearchSeDomain()
        }
        if(val === 'five'){
          for(let i = 0;i< this.DISTRICTS[0].province.length;i++){
            if(this.LinkmanForm.r_province_cn === this.DISTRICTS[0].province[i].area_cn){
              this.cityInfo.city = this.LinkmanForm.r_province_cn === '' ? '北京市' : this.LinkmanForm.r_province_cn
              this.cityInfo.area = this.LinkmanForm.r_city_cn === '' ? '北京市' : this.LinkmanForm.r_city_cn
              return true
            }
          }
          this.cityInfo.city = '北京市'
          this.cityInfo.area = '北京市'
          return false
        }
        if(val === 'six'){
          this.GetRecord()
        }
      },
      city(){
        for(let i in this.DISTRICTS){
          if(this.DISTRICTS[i].area_cn == this.cityInfo.province){
            this.LinkmanForm.r_country_uk = this.DISTRICTS[i].area_en
            let province = this.DISTRICTS[i].province
            for(let j in province){
              if(province[j].area_cn == this.cityInfo.city){
                this.LinkmanForm.r_province_uk = province[j].area_en
                let city = province[j].city
                for(let k in city){
                  if(city[k].area_cn == this.cityInfo.area){
                    this.LinkmanForm.r_city_uk = city[k].area_en
                  }
                }
              }
            }
          }
        }
      },
      area(){
        for(let i in this.DISTRICTS){
          if(this.DISTRICTS[i].area_cn == this.cityInfo.province){
            this.LinkmanForm.r_country_uk = this.DISTRICTS[i].area_en
            let province = this.DISTRICTS[i].province
            for(let j in province){
              if(province[j].area_cn == this.cityInfo.city){
                this.LinkmanForm.r_province_uk = province[j].area_en
                let city = province[j].city
                for(let k in city){
                  if(city[k].area_cn == this.cityInfo.area){
                    this.LinkmanForm.r_city_uk = city[k].area_en
                  }
                }
              }
            }
          }
        }
      },
      r_user_name_cn(val,oldval){
        if(oldval != ''){
          this.LinkmanForm.r_user_name_uk = ConvertPinyin(val)
        }
      },
      r_street_cn(val,oldval){
        if(oldval != ''){
          this.LinkmanForm.r_street_uk = ConvertPinyin(val)
        }
      }
    },
    methods:{
      async config() {
        this.domain = sessionStorage.getItem('domain') ? JSON.parse(sessionStorage.getItem('domain')) : {'id': this.$route.params.id}
        await this.DomainQuery()
        this.SearchSeDomain()
        this.getArea()
      },
      backToMyDomain(){
        this.$router.push('/domainList')
      },
      async SearchSeDomain() {
        this.listLoading = true
        let data = 'cmd=jiexi_query'+
          '&count=10'+
          '&page='+ this.page1 +
          '&domainname='+ this.domain.name +
          '&title='+ this.search
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST',data)
        if(vueData.response == 200 ) {
          this.total1 = vueData.data ? vueData.data.allcount : 0
          this.analyList = vueData.data ? vueData.data.content.map((item, index) => {
            return {
              index:index,
              type:item.set_type == 'aaaa' ? 'ipv6' : item.set_type,
              title:item.title,
              content:item.content,
              ttl:item.ttl,
              mx:item.mx_priority == 0 ? '' : item.mx_priority,
              domainname:item.domainname,
              id:item.id
            }
          }) : []
          this.listLoading = false
        }else {
          this.listLoading = false
          this.dialogWarning = true
          this.warningMsg = vueData.msg
        }
      },
      async DomainQuery() {
        this.loading2 = true
        let data = 'cmd=domain_query'+
          '&id='+ this.domain.id
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST',data)
        if(vueData.response == 200 ) {
          this.loading2 = false
          let data = vueData.info.msg.data
          this.domain.name = data.domain
          this.domain.password = data.password
          this.domain.org = vueData.info.msg.org
          this.dn_top = vueData.dn_top
          this.organizeman_cn = data.r_organize_name_cn
          this.organizeman_uk = data.r_organize_name_uk
          this.street_cn = data.r_street_cn
          this.street_uk = data.r_street_uk
          this.applyDate = data.applyDate
          this.expireDate = data.expireDate
          if((data.dns[0] === 'ns11.xincache.com' && data.dns[1] === 'ns12.xincache.com') || (data.dns[0] === 'dns-ch.xinnet.com' && data.dns[1] === 'dns-ch2.xinnet.com')){
            this.changedns = '1'
          }else{
            this.changedns = '2'
            this.dns1 = data.dns[0]
            this.dns2 = data.dns[1]
          }
          this.dns = data.dns
          this.dnsstr = data.dns.join(',')
          this.$refs.alert.style.visibility = 'visible'
          this.shiming = vueData.shiming.auditStatus
          this.isChinese = vueData.isChinese
          this.LinkmanForm.r_organize_name_cn = data.r_organize_name_cn
          this.LinkmanForm.r_user_name_cn = data.r_user_name_cn
          this.LinkmanForm.r_street_cn = data.r_street_cn === 'null' ? '' : data.r_street_cn
          this.LinkmanForm.r_zip = data.r_zip === 'null' ? '' : data.r_zip
          this.LinkmanForm.r_phone = data.r_phone === 'null' ? '' : data.r_phone
          this.LinkmanForm.r_phone_c = data.r_phone_c === 'null' ? '' : data.r_phone_c
          this.LinkmanForm.r_phone_a = data.r_phone_a === 'null' ? '' : data.r_phone_a
          this.LinkmanForm.r_phone_n = data.r_phone_n === 'null' ? '' : data.r_phone_n
          this.LinkmanForm.r_email = data.r_email === 'null' ? '' : data.r_email
          this.LinkmanForm.r_organize_name_uk = data.r_organize_name_uk
          this.LinkmanForm.r_user_name_uk = data.r_user_name_uk === 'null' ? '' : data.r_user_name_uk
          this.LinkmanForm.r_province_uk = data.r_province_uk === 'null' ? '' : data.r_province_uk
          this.LinkmanForm.r_city_uk = data.r_city_uk === 'null' ? '' : data.r_city_uk
          this.LinkmanForm.r_street_uk = data.r_street_uk === 'null' ? '' : data.r_street_uk
          this.LinkmanForm.r_province_cn = data.r_province_cn === 'null' ? '' : data.r_province_cn
          this.LinkmanForm.r_city_cn = data.r_city_cn === 'null' ? '' : data.r_city_cn

        }else {
          this.loading2 = false
          this.dialogWarning = true
          this.warningMsg = vueData.msg
        }
      },
      handleCurrentChange1(val) {
        this.page1 = val;
        this.SearchSeDomain()
      },
      handleSizeChange1(val) {
        this.count1 = val
        this.SearchSeDomain()
      },
      handleCurrentChange2(val) {
        this.page2 = val;
        this.GetRecord()
      },
      handleSizeChange2(val) {
        this.count2 = val
        this.GetRecord()
      },
      add(){
        if(this.analyList[0]){
          if(this.analyList[0].index === -1){
            return
          }
        }
        this.analyList.unshift(
          {
            index:-1,
            type: 'a',
            title: '',
            content: '',
            ttl: '120',
            mx: '',
          }
        )
        this.tableidx = -1
      },
      revise(idx){
        this.tableidx = idx
        this.oldcontent = this.analyList[idx].content
        if(this.analyList[0].index === -1){
          this.analyList.shift()
        }
      },
      URLencode(sStr) {
        return sStr.replace(/\+/g, '%2B').replace(/\"/g,'%22').replace(/\'/g, '%27').replace(/\//g,'%2F');
      },
      async setUp(){
        this.dialogLoading = true
        let formData = new window.FormData();
        formData.append('cmd', 'jiexi_add')
        formData.append('set_type', this.analyList[0].type)
        formData.append('domainname', this.domain.name)
        formData.append('mx', this.analyList[0].mx)
        formData.append('title', this.analyList[0].title)
        formData.append('content', this.URLencode(this.analyList[0].content))
        formData.append('ttl', this.analyList[0].ttl)
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST',formData)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.SearchSeDomain()}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async save(id,mx,content,ttl,type,title){
        this.dialogLoading = true
        let data = 'cmd=jiexi_modify'+
          '&ac_id='+ id +
          '&mx='+ mx +
          '&content='+ this.URLencode(content) +
          '&domainname='+ this.URLencode(this.domain.name) +
          '&ttl='+ ttl +
          '&type='+ type +
          '&title='+ this.URLencode(title)+
          '&oldcontent='+ this.URLencode(this.oldcontent)
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          this.tableidx = 1000
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.SearchSeDomain()}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      cancel(){
        this.tableidx = 1000
        this.SearchSeDomain()
      },
      async delJieru(id,type,title,content){
        this.dialogLoading = true
        let data = 'cmd=jiexi_del'+
        '&domainname='+ this.URLencode(this.domain.name) +
         '&ac_id='+ id+
         '&type='+ type +
          '&title='+ this.URLencode(title) +
          '&content='+ this.URLencode(content)
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          this.tableidx = 1000
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.SearchSeDomain()}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      printdiv(){
        let newstr = document.getElementById("div_print").innerHTML;
        let oldstr = document.body.innerHTML;
        document.body.innerHTML =newstr;
        window.print();
        window.location.reload();
        this.activeName = 'second'
      },
      goCertificate(){
        window.open('/ertificate.html?id='+ this.domain.id + '&org='+ this.domain.org)
      },
      choiceDns(val) {
        if(val == 1 && this.isChinese === 'E'){
          this.dns1 = 'ns11.xincache.com'
          this.dns2 = 'ns12.xincache.com'
        }
        if(val == 1 && this.isChinese === 'G'){
          this.dns1 = 'dns-ch.xinnet.com'
          this.dns2 = 'dns-ch2.xinnet.com'
        }
        if(val == 2){
          this.dns1 = this.dns[0]
          this.dns2 = this.dns[1]
        }
      },
      async ChangeDns() {
        this.dialogLoading = true
        let data = 'cmd=updns'+
          '&domainname='+ this.domain.name +
          '&org='+ this.domain.org +
          '&server1='+ this.dns1 +
          '&server2='+ this.dns2
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg.data, click () {self.DomainQuery()}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async GetRecord() {
        let data = 'cmd=ac_log'+
          '&count=10'+
          '&page='+ this.page2+
          '&domainname='+ this.domain.name
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST',data)
        if(vueData.response == 200 ) {
          this.total2 = vueData.data.allcount
          this.recordList = vueData.data.content.map((item, index) => {
            return {
              settime:item.settime,
              ac_type:item.ac_type,
              set_type:item.set_type,
              domainname:item.domainname,
              content:item.content,
              ttl:item.ttl,
              ac_ip:item.ac_ip,
              ac_from:item.ac_from,
              title:item.title,
            }
          })
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submit()
          } else {
            return false;
          }
        });
      },
      async submit() {
        this.dialogLoading = true
        let r_country_uk = this.cityInfo.province === '中国' ? 'CN' : 'qita'
        let data = 'cmd=upuserinfo'+
          '&org='+ this.domain.org +
          '&domainname='+ this.domain.name +
          '&r_user_name_cn='+ this.LinkmanForm.r_user_name_cn +
          '&r_user_name_uk=' + this.LinkmanForm.r_user_name_uk +
          '&r_country_uk=' + r_country_uk +
          '&r_province_cn=' + this.cityInfo.city +
          '&r_province_uk=' + this.LinkmanForm.r_province_uk +
          '&r_city_cn=' + this.cityInfo.area +
          '&r_city_uk=' + this.LinkmanForm.r_city_uk +
          '&r_street_cn=' + this.LinkmanForm.r_street_cn +
          '&r_street_uk=' + this.LinkmanForm.r_street_uk +
          '&r_email=' + this.LinkmanForm.r_email +
          '&r_phone_c=' + this.LinkmanForm.r_phone_c +
          '&r_phone_a=' + this.LinkmanForm.r_phone_a +
          '&r_phone_n=' + this.LinkmanForm.r_phone_n +
          '&r_zip=' + this.LinkmanForm.r_zip
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          this.$dialog({type:'success', info: vueData.msg.data, click () {}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async getArea() {
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST','cmd=area_dic')
        if(state.code === '000' ) {
          this.DISTRICTS = vueData
        }else {
          this.$toast('请刷新页面...','fail')
        }
      },
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
    background-color: #fff;
  }
  .page-main { border: 0}
  .panel-heading { padding: 5px 0 0 0; }
  .hideleft { margin-left: 80px; }
  .server-header {
    height: 96px;
    margin-top: 18px;
    margin-bottom: 30px;
    text-indent: 120px;
    background-repeat: no-repeat;
    background-position: left center;
  }
  .server-header.domain {
    position: relative;
    background: url(../../assets/imgs/domain-bg.png) no-repeat left center;
  }
  .header-center-text {
    position: absolute;
    left: 23px;
    top: 27px;
    width: 50px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    text-indent: 0;
    color: #fff;
    font-size: 12px;
  }
  .server-header > p {
    margin: 10px 0;
    font-size: 12px;
    color: #a0a2a3;
  }
  .server-header > p > span {
    margin-right: 25px;
  }
  .domain-analy .el-input {
    width: 200px;
  }
  .alert-warn {
    margin-bottom: 20px;
  }
  .int a img,img{border:0;vertical-align:middle;}
  .int a {text-decoration:none;color:#666;}
  .int a:hover {color:#e53639;}
  .int a:focus {outline-style:none;}
  .int .blue{color:#18499d;background:none!important;}
  .int .red{color:#bf1a20;background:none!important;}
  .int{width:616px;height:876px;margin:20px auto 0;background:url(../../assets/imgs/xinnet-bg.png) no-repeat 0 0;position:relative;}/*international*/
  .int-logo{display:block;margin:0 auto;padding:80px 0 40px;}
  .int-title{display:block;margin:0 auto;}
  .int-text{width:505px;margin:0 auto;position:relative;}
  .int-p{font-size:12px;line-height:18px;margin:8px 0 0;}
  .int-p2{font-size:12px;line-height:18px;text-align:center;padding:10px 0 0;}
  .int-p span{padding:0 3px;}
  .int-tab{margin:10px auto;}
  .int-tab td{padding:0 0 0 3px;}
  .int-seal{position:absolute;bottom:20px;right:0px;}
  .int-p3{width:616px;position:absolute;bottom:35px;color:#bf1a20;text-align:center;}
  .int-p3 a{color:#bf1a20;}

  .int-35{
    width:616px;height:894px;margin:20px auto 0;position:relative;
    border-top: 18px solid #CC3333;
    border-right: 18px solid #CC3333;
    border-bottom: 18px solid #CC3333;
    border-left: 18px solid #CC3333;
    outline: 1px solid #000;
    line-height: 17px;
  }
  .int-35 table {
    border-collapse:collapse;
  }
  .int table {
    border-collapse:collapse;
  }
  .int-text-35{width:496px;margin:0 auto;position:relative;}

  .box-card { width: 500px}
  .change-info-form .el-input,.el-select {
    width: 300px;
  }
  .change-info-form .phone-c.el-input{
    width: 54px;
  }
  .change-info-form .phone-a.el-input{
    width: 54px;
  }
  .change-info-form .phone-n.el-input{
    width: 163px;
  }
  .jiexi .el-input,.el-select {
    width: auto;
  }
  .el-form-item.tixing .el-form-item__label {color:red;}
</style>




// WEBPACK FOOTER //
// src/pages/product/domain.vue